import { useState } from "react"

/**
 * Controls a table behavior
 * @param {useTableArgs}
 */
export function useTable({ multiple, selected: initialSelection = [] } = {}) {
  if (!Array.isArray(initialSelection)) {
    initialSelection = [initialSelection]
  }

  const [selectedRows, setSelectedRow] = useState(initialSelection)

  const onSelect = ({ row: index, selected }) => {
    setSelectedRow((previousSelected) => {
      const rowIndex = previousSelected.findIndex((value) => value === index)

      if (rowIndex >= 0) {
        if (!selected) {
          const newSelected = previousSelected.slice()
          newSelected.splice(rowIndex, 1)

          return newSelected
        }

        return previousSelected
      }
      if (selected) {
        if (multiple) {
          return previousSelected.concat(index)
        }

        return [index]
      }

      return previousSelected
    })
  }

  return { onSelect, selectedRows }
}

/**
 *
 * @typedef {Object} useTableArgs
 *
 * @property {number | number[]} selected the initial selected values
 * @property {boolean} multiple If true multiple roles can be simultaneously selected
 */
